import Vue from 'vue';
import Component from 'vue-class-component';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
]);
import Router from 'vue-router';
import { Authority } from '@/shared/security/authority';
const Home = () => import('@/views/home/home.vue');
const Error = () => import('@/views/error/error.vue');
const Login = () => import('@/views/login/login.vue');
const Logout = () => import('@/views/logout/logout.vue');
const FirstLogin = () => import('@/views/login/firstLogin/first-login.vue');
const First2faLogin = () => import('@/views/login/firstLogin/first-2fa-login.vue');
const ConsentRelyingParty = () => import('@/views/consent/consent-rp.vue');
const Authenticate = () => import('@/views/authenticate/authenticate.vue');
const ConsentRedirectServlet = () => import('@/views/consent/consent-redirect-servlet.vue');

/* tslint:disable */

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: { error500: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/first-login',
      name: 'FirstLogin',
      component: FirstLogin,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/authenticate',
      name: 'Authenticate',
      component: Authenticate
    },
    {
      path: '/consent',
      name: 'ConsentRelyingParty',
      component: ConsentRelyingParty,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/consent-rs',
      name: 'ConsentRedirectServlet',
      component: ConsentRedirectServlet
    },
    {
      path: '/login-2fa-register',
      name: 'First2faLogin',
      component: First2faLogin,
      meta: { authorities: [Authority.USER] }
    },
  ]
});
